// @flow
import { takeLatest, call, select, put } from 'redux-saga/effects';
import { FETCH_SOURCES_REQUEST } from './actionTypes';
import ApiSources from '../../sdk/sources/ApiSources';
import { fetchSourcesFailed, fetchSourcesStart, fetchSourcesSuccess } from './actions';
import normalizeSource from '../../normalize/source';
import { getVerticalId, getVerticalName, getCountryCode } from '~/common/selectors/config';

export function* getSources(): Generator<*, *, *> {
  try {
    const countryCode: string = yield select(getCountryCode);
    const verticalId: number = yield select(getVerticalId);
    const verticalName: string = yield select(getVerticalName);

    if (!countryCode || !verticalId) {
      return false;
    }

    yield put(fetchSourcesStart());
    const response: Array<SourceAPI> = yield call([ApiSources, ApiSources.fetchSources], {
      countryCode,
      verticalId,
      verticalName,
    });

    return yield put(fetchSourcesSuccess(normalizeSource(response)));
  } catch (error) {
    return yield put(fetchSourcesFailed(error));
  }
}

export default function* listSagas(): Generator<*, *, *> {
  yield takeLatest(FETCH_SOURCES_REQUEST, getSources);
}



// WEBPACK FOOTER //
// ./app/Sources/list/sagas.js